import styled from 'styled-components/macro';

import mq from '../../utils/mediaQueriesBp';

export const H3 = styled.h3`
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: ${p => p.theme.colors.black};
  margin: 0;

  ${mq('laptop')} {
    font-size: ${(24 / 1024) * 100}vw;
    line-height: ${(30 / 1024) * 100}vw;
  }

  ${mq('desktop')} {
    font-size: ${(24 / 1440) * 100}vw;
    line-height: ${(30 / 1440) * 100}vw;
  }

  ${mq('large')} {
    font-size: 24px;
    line-height: 30px;
  }
`;

export default H3;
